// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/event.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ListAuditLogsRequest, ListAuditLogsResponse, WatchEventsRequest, WatchEventsResponse } from "./event_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.EventService
 */
export const EventService = {
  typeName: "gitpod.v1.EventService",
  methods: {
    /**
     * Streams events for all projects, runners, environments, tasks, and services based on the
     * specified scope.
     *
     * Use this method to:
     * - Monitor resource changes in real-time
     * - Track system events
     * - Receive notifications
     *
     * The scope parameter determines which events to watch:
     * - Organization scope (default): Watch all organization-wide events including projects,
     *   runners and environments. Task and service events are not included. Use by setting
     *   organization=true or omitting the scope.
     * - Environment scope: Watch events for a specific environment, including its tasks,
     *   task executions, and services. Use by setting environment_id to the UUID of the
     *   environment to watch.
     *
     * @generated from rpc gitpod.v1.EventService.WatchEvents
     */
    watchEvents: {
      name: "WatchEvents",
      I: WatchEventsRequest,
      O: WatchEventsResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Lists audit logs with filtering and pagination options.
     *
     * Use this method to:
     * - View audit history
     * - Track user actions
     * - Monitor system changes
     *
     * ### Examples
     *
     * - List all logs:
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Filter by actor:
     *
     *   ```yaml
     *   filter:
     *     actorIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
     *     actorPrincipals: ["PRINCIPAL_USER"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.EventService.ListAuditLogs
     */
    listAuditLogs: {
      name: "ListAuditLogs",
      I: ListAuditLogsRequest,
      O: ListAuditLogsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

